import {combineReducers} from "redux";

import listeCommandesReducer from "./listeCommandes"


export default combineReducers({
    listeCommandes: listeCommandesReducer,
});